// Etichette del link per l'amministratore: approvate da Alfonso il 22/10 (spec § 11, «Link»). Il singolare di «in
// lettura» segue i singolari approvati il 23/10 («1 bolletta · 1 condominio»).

export const LINK_SCADUTO = "Link scaduto";

/** «3 bollette ancora in lettura», «1 bolletta ancora in lettura». */
export function ancoraInLettura(n: number): string {
  return n === 1 ? "1 bolletta ancora in lettura" : `${n} bollette ancora in lettura`;
}

/** Sotto il titolo della copia (decisione di Alfonso del 24/10): «Preparato da Agenzia X il 24/10/2026», o senza il
 *  nome dell'agenzia «Preparato il 24/10/2026». */
export function preparato(agenzia: string | null, data: string): string {
  return agenzia ? `Preparato da ${agenzia} il ${data}` : `Preparato il ${data}`;
}
